module.exports = __webpack_public_path__ + "5811c3345f084a8529a746507303030b.MP3";